import { translateFr as tfr } from "@/i18n";
// Athlynx Calendar — Event type meta
// Centralised mapping for event categories used across views,
// editor, detail sheet, legend and filters.
// Classes are theme-aware: light-mode values first, dark-mode values behind `dark:`
// (dark values are the original design — unchanged).
import {
  Dumbbell, Users, ClipboardList, Trophy, Video, FileWarning,
  PhoneCall, Building2, ListChecks, Calendar as CalIcon,
} from "lucide-react";

// Each meta entry exposes the Tailwind classes used to:
// - tint the card background      (bg)
// - draw the left/colored border  (border)
// - color the title & icon        (text)
// - dot indicator                 (dot)
// - chip background (filters/legend)
export const EVENT_TYPES = {
  training: {
    key: "training",
    label: tfr("Entraînement"),
    Icon: Dumbbell,
    bg: "bg-violet-100 hover:bg-violet-200/70 dark:bg-violet-500/10 dark:hover:bg-violet-500/15",
    border: "border-violet-500 dark:border-violet-500/40",
    text: "text-violet-900 dark:text-violet-300",
    dot: "bg-violet-500 dark:bg-violet-400",
    chip: "bg-violet-100 text-violet-800 border-violet-300 dark:bg-violet-500/15 dark:text-violet-300 dark:border-violet-500/30",
    legend: tfr("Entraînement"),
    legendDot: "bg-violet-500 dark:bg-violet-400",
  },
  meeting: {
    key: "meeting",
    label: tfr("Réunion"),
    Icon: Users,
    bg: "bg-sky-100 hover:bg-sky-200/70 dark:bg-sky-500/10 dark:hover:bg-sky-500/15",
    border: "border-sky-500 dark:border-sky-500/40",
    text: "text-sky-900 dark:text-sky-300",
    dot: "bg-sky-500 dark:bg-sky-400",
    chip: "bg-sky-100 text-sky-800 border-sky-300 dark:bg-sky-500/15 dark:text-sky-300 dark:border-sky-500/30",
    legend: tfr("Réunion"),
    legendDot: "bg-sky-500 dark:bg-sky-400",
  },
  "rdv-club": {
    key: "rdv-club",
    label: "RDV Club",
    Icon: Building2,
    bg: "bg-blue-100 hover:bg-blue-200/70 dark:bg-blue-500/10 dark:hover:bg-blue-500/15",
    border: "border-blue-500 dark:border-blue-500/40",
    text: "text-blue-900 dark:text-blue-300",
    dot: "bg-blue-500 dark:bg-blue-400",
    chip: "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-500/15 dark:text-blue-300 dark:border-blue-500/30",
    legend: "RDV Club",
    legendDot: "bg-blue-500 dark:bg-blue-400",
  },
  tactique: {
    key: "tactique",
    label: tfr("Tactique"),
    Icon: ClipboardList,
    bg: "bg-amber-100 hover:bg-amber-200/70 dark:bg-amber-500/10 dark:hover:bg-amber-500/15",
    border: "border-amber-500 dark:border-amber-500/40",
    text: "text-amber-900 dark:text-amber-300",
    dot: "bg-amber-500 dark:bg-amber-400",
    chip: "bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-500/15 dark:text-amber-300 dark:border-amber-500/30",
    legend: tfr("Tactique"),
    legendDot: "bg-amber-500 dark:bg-amber-400",
  },
  prep: {
    key: "prep",
    label: tfr("Préparation"),
    Icon: Trophy,
    bg: "bg-emerald-100 hover:bg-emerald-200/70 dark:bg-emerald-500/10 dark:hover:bg-emerald-500/15",
    border: "border-emerald-500 dark:border-emerald-500/40",
    text: "text-emerald-900 dark:text-emerald-300",
    dot: "bg-emerald-500 dark:bg-emerald-400",
    chip: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-500/15 dark:text-emerald-300 dark:border-emerald-500/30",
    legend: tfr("Préparation"),
    legendDot: "bg-emerald-500 dark:bg-emerald-400",
  },
  match: {
    key: "match",
    label: "Match",
    Icon: Trophy,
    bg: "bg-cyan-100 hover:bg-cyan-200/70 dark:bg-cyan-500/10 dark:hover:bg-cyan-500/15",
    border: "border-cyan-500 dark:border-cyan-500/40",
    text: "text-cyan-900 dark:text-cyan-300",
    dot: "bg-cyan-500 dark:bg-cyan-400",
    chip: "bg-cyan-100 text-cyan-800 border-cyan-300 dark:bg-cyan-500/15 dark:text-cyan-300 dark:border-cyan-500/30",
    legend: "Match",
    legendDot: "bg-cyan-500 dark:bg-cyan-400",
  },
  video: {
    key: "video",
    label: tfr("Analyse vidéo"),
    Icon: Video,
    bg: "bg-teal-100 hover:bg-teal-200/70 dark:bg-teal-500/10 dark:hover:bg-teal-500/15",
    border: "border-teal-500 dark:border-teal-500/40",
    text: "text-teal-900 dark:text-teal-300",
    dot: "bg-teal-500 dark:bg-teal-400",
    chip: "bg-teal-100 text-teal-800 border-teal-300 dark:bg-teal-500/15 dark:text-teal-300 dark:border-teal-500/30",
    legend: tfr("Vidéo"),
    legendDot: "bg-teal-500 dark:bg-teal-400",
  },
  relance: {
    key: "relance",
    label: tfr("Relance"),
    Icon: PhoneCall,
    bg: "bg-rose-100 hover:bg-rose-200/70 dark:bg-rose-500/10 dark:hover:bg-rose-500/15",
    border: "border-rose-500 dark:border-rose-500/40",
    text: "text-rose-900 dark:text-rose-300",
    dot: "bg-rose-500 dark:bg-rose-400",
    chip: "bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/30",
    legend: tfr("Relance"),
    legendDot: "bg-rose-500 dark:bg-rose-400",
  },
  deadline: {
    key: "deadline",
    label: "Deadline",
    Icon: FileWarning,
    bg: "bg-red-100 hover:bg-red-200/70 dark:bg-red-500/10 dark:hover:bg-red-500/15",
    border: "border-red-500 dark:border-red-500/40",
    text: "text-red-900 dark:text-red-300",
    dot: "bg-red-500 dark:bg-red-400",
    chip: "bg-red-100 text-red-800 border-red-300 dark:bg-red-500/15 dark:text-red-300 dark:border-red-500/30",
    legend: "Deadline",
    legendDot: "bg-red-500 dark:bg-red-400",
  },
  task: {
    key: "task",
    label: tfr("Tâche"),
    Icon: ListChecks,
    bg: "bg-yellow-100 hover:bg-yellow-200/70 dark:bg-yellow-500/10 dark:hover:bg-yellow-500/15",
    border: "border-yellow-500 dark:border-yellow-500/40",
    text: "text-yellow-900 dark:text-yellow-300",
    dot: "bg-yellow-500 dark:bg-yellow-400",
    chip: "bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-500/15 dark:text-yellow-300 dark:border-yellow-500/30",
    legend: tfr("Tâche"),
    legendDot: "bg-yellow-500 dark:bg-yellow-400",
  },
  other: {
    key: "other",
    label: "Autre",
    Icon: CalIcon,
    bg: "bg-zinc-200/70 hover:bg-zinc-200 dark:bg-zinc-500/10 dark:hover:bg-zinc-500/15",
    border: "border-zinc-500 dark:border-zinc-500/40",
    text: "text-zinc-800 dark:text-zinc-300",
    dot: "bg-zinc-500 dark:bg-zinc-400",
    chip: "bg-zinc-200/70 text-zinc-800 border-zinc-300 dark:bg-zinc-500/15 dark:text-zinc-300 dark:border-zinc-500/30",
    legend: "Autre",
    legendDot: "bg-zinc-500 dark:bg-zinc-400",
  },
  // Legacy aliases (backwards-compat with older events)
  call: {
    key: "call", label: "Appel", Icon: PhoneCall,
    bg: "bg-sky-100 hover:bg-sky-200/70 dark:bg-sky-500/10 dark:hover:bg-sky-500/15",
    border: "border-sky-500 dark:border-sky-500/40",
    text: "text-sky-900 dark:text-sky-300",
    dot: "bg-sky-500 dark:bg-sky-400",
    chip: "bg-sky-100 text-sky-800 border-sky-300 dark:bg-sky-500/15 dark:text-sky-300 dark:border-sky-500/30",
    legend: "Appel", legendDot: "bg-sky-500 dark:bg-sky-400",
  },
  "follow-up": {
    key: "follow-up", label: tfr("Relance"), Icon: PhoneCall,
    bg: "bg-rose-100 hover:bg-rose-200/70 dark:bg-rose-500/10 dark:hover:bg-rose-500/15",
    border: "border-rose-500 dark:border-rose-500/40",
    text: "text-rose-900 dark:text-rose-300",
    dot: "bg-rose-500 dark:bg-rose-400",
    chip: "bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-500/15 dark:text-rose-300 dark:border-rose-500/30",
    legend: tfr("Relance"), legendDot: "bg-rose-500 dark:bg-rose-400",
  },
};

export const TYPE_ORDER = [
  "training", "meeting", "rdv-club", "tactique", "prep",
  "match", "video", "relance", "deadline", "task", "other",
];

export const getMeta = (type) => EVENT_TYPES[type] || EVENT_TYPES.other;

// Filter categories shown in the dropdown.
// Each filter maps to one or more event type keys.
export const FILTER_CATEGORIES = [
  { value: "all", label: tfr("Toutes les catégories"), types: null },
  { value: "training", label: tfr("Entraînements"), types: ["training"] },
  { value: "meeting", label: tfr("Réunions"), types: ["meeting"] },
  { value: "rdv-club", label: "RDV Club", types: ["rdv-club"] },
  { value: "tactique", label: tfr("Tactique"), types: ["tactique"] },
  { value: "prep", label: tfr("Préparation"), types: ["prep"] },
  { value: "match", label: "Matchs", types: ["match"] },
  { value: "video", label: tfr("Vidéo"), types: ["video"] },
  { value: "relance", label: "Relances", types: ["relance", "follow-up", "call"] },
  { value: "deadline", label: "Deadlines", types: ["deadline"] },
  { value: "task", label: tfr("Tâches"), types: ["task"] },
];

export const PRIORITIES = [
  { value: "low", label: tfr("Basse"), className: "text-muted-foreground" },
  { value: "normal", label: "Normale", className: "text-foreground" },
  { value: "high", label: "Haute", className: "text-amber-600 dark:text-amber-400" },
  { value: "urgent", label: tfr("Urgente"), className: "text-red-600 dark:text-red-400" },
];

export const STATUSES = [
  { value: "planned", label: tfr("Prévu") },
  { value: "done", label: tfr("Fait") },
  { value: "cancelled", label: tfr("Annulé") },
];

export const REMINDERS = [
  { value: "none", label: tfr("Aucun") },
  { value: "15m", label: tfr("15 minutes avant") },
  { value: "1h", label: tfr("1 heure avant") },
  { value: "24h", label: tfr("24 heures avant") },
];
